SlideView = require("views/slide")

class ListView extends SlideView
  template: require("./template")

  events:
    "click .btn-done": "submit"

module.exports = ListView
